// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Nodes Hub — light surfaces */

.f1aYrstYcWa_E3xywDmP {
    position: relative;
    width: 100%;
    box-sizing: border-box;
}

.abLzaRFanUOEtDEb8y4B {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
    box-sizing: border-box;
    text-align: left;
    font-size: 0.8125rem;
    font-weight: 500;
    padding: 8px 10px;
    border-radius: 8px;
    border: 1px solid #d8d4c2;
    background: #ffffff;
    color: #1e1f23;
    cursor: pointer;
    font-family: inherit;
}

.abLzaRFanUOEtDEb8y4B:focus {
    outline: none;
    border-color: #fbaa69;
    box-shadow: 0 0 0 2px rgba(251, 170, 105, 0.25);
}

.iSBjCntDSNM4S6SYMzm_ {
    flex: 1;
    min-width: 0;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
    line-height: 1.35;
}

.k__1kRq0DRflkyTB3JgE {
    flex-shrink: 0;
    font-size: 0.65rem;
    opacity: 0.75;
    margin-top: 3px;
    color: #7a786d;
    transition: transform 0.15s ease;
}

.AlNRccLxg1LHAROcXISZ {
    transform: rotate(180deg);
}

.kFEtJadDNpVMMfxm8ccJ {
    position: absolute;
    left: 0;
    right: 0;
    z-index: 30;
    margin-top: 4px;
    max-height: min(280px, 45vh);
    overflow-y: auto;
    overflow-x: hidden;
    padding: 4px;
    border-radius: 8px;
    border: 1px solid #d8d4c2;
    background: #ffffff;
    box-shadow: 0 8px 28px rgba(30, 31, 35, 0.12);
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.fdLtB8082BHZ2CLnUu2k {
    display: block;
    width: 100%;
    box-sizing: border-box;
    text-align: left;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
    line-height: 1.35;
    padding: 8px 10px;
    margin: 0;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: #1e1f23;
    font-size: 0.8125rem;
    font-weight: 500;
    font-family: inherit;
    cursor: pointer;
}

.fdLtB8082BHZ2CLnUu2k:hover {
    background: #f3f1e6;
}

.I2GKyDCxKhheFOJ28XWD {
    background: rgba(251, 170, 105, 0.18);
    color: #1e1f23;
}

.fdLtB8082BHZ2CLnUu2k:focus {
    outline: none;
    box-shadow: inset 0 0 0 2px rgba(251, 170, 105, 0.45);
}
`, "",{"version":3,"sources":["webpack://./src/components/packages/ForkFamilyPicker.hub.module.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;IACI,kBAAkB;IAClB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,QAAQ;IACR,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,+CAA+C;AACnD;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,6CAA6C;IAC7C,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qDAAqD;AACzD","sourcesContent":["/* Nodes Hub — light surfaces */\n\n.root {\n    position: relative;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.trigger {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 8px;\n    width: 100%;\n    box-sizing: border-box;\n    text-align: left;\n    font-size: 0.8125rem;\n    font-weight: 500;\n    padding: 8px 10px;\n    border-radius: 8px;\n    border: 1px solid #d8d4c2;\n    background: #ffffff;\n    color: #1e1f23;\n    cursor: pointer;\n    font-family: inherit;\n}\n\n.trigger:focus {\n    outline: none;\n    border-color: #fbaa69;\n    box-shadow: 0 0 0 2px rgba(251, 170, 105, 0.25);\n}\n\n.triggerLabel {\n    flex: 1;\n    min-width: 0;\n    white-space: normal;\n    overflow-wrap: anywhere;\n    word-break: break-word;\n    line-height: 1.35;\n}\n\n.triggerChevron {\n    flex-shrink: 0;\n    font-size: 0.65rem;\n    opacity: 0.75;\n    margin-top: 3px;\n    color: #7a786d;\n    transition: transform 0.15s ease;\n}\n\n.triggerChevronOpen {\n    transform: rotate(180deg);\n}\n\n.listbox {\n    position: absolute;\n    left: 0;\n    right: 0;\n    z-index: 30;\n    margin-top: 4px;\n    max-height: min(280px, 45vh);\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 4px;\n    border-radius: 8px;\n    border: 1px solid #d8d4c2;\n    background: #ffffff;\n    box-shadow: 0 8px 28px rgba(30, 31, 35, 0.12);\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.option {\n    display: block;\n    width: 100%;\n    box-sizing: border-box;\n    text-align: left;\n    white-space: normal;\n    overflow-wrap: anywhere;\n    word-break: break-word;\n    line-height: 1.35;\n    padding: 8px 10px;\n    margin: 0;\n    border: none;\n    border-radius: 6px;\n    background: transparent;\n    color: #1e1f23;\n    font-size: 0.8125rem;\n    font-weight: 500;\n    font-family: inherit;\n    cursor: pointer;\n}\n\n.option:hover {\n    background: #f3f1e6;\n}\n\n.optionSelected {\n    background: rgba(251, 170, 105, 0.18);\n    color: #1e1f23;\n}\n\n.option:focus {\n    outline: none;\n    box-shadow: inset 0 0 0 2px rgba(251, 170, 105, 0.45);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `f1aYrstYcWa_E3xywDmP`,
	"trigger": `abLzaRFanUOEtDEb8y4B`,
	"triggerLabel": `iSBjCntDSNM4S6SYMzm_`,
	"triggerChevron": `k__1kRq0DRflkyTB3JgE`,
	"triggerChevronOpen": `AlNRccLxg1LHAROcXISZ`,
	"listbox": `kFEtJadDNpVMMfxm8ccJ`,
	"option": `fdLtB8082BHZ2CLnUu2k`,
	"optionSelected": `I2GKyDCxKhheFOJ28XWD`
};
export default ___CSS_LOADER_EXPORT___;
